import React, { useState, useRef, useEffect } from "react";
import "../css/CreateNewJob.css";
import ic_dropdown_select_car from "../img/ic_dropdown_select_car.png";
import ic_trash from "../img/ic_trash.png";
import Header from "./Header";
import "../css/CommonStyle.css";
import BRONZ_NEW from "../img/BRONZ_NEW.jpg";
import SILVER_NEW from "../img/SILVER_NEW.jpg";
import GOLD_NEW from "../img/GOLD_NEW.jpg";
import PLATINUM_NEW from "../img/PLATINUM_NEW.jpg";
import ic_collapse_arrow from "../img/ic_collapse_arrow.png";
import ic_expand_arrow from "../img/ic_expand_arrow.png";
import Technician_list_popup from "./Technician_list_popup";
import Confirm_job_popup from "./Confirm_job_popup";
import Add_service_popup from "./Add_service_popup";
import axios from "axios";
import ic_clear_search_box from "../img/ic_close_search_box.png";
import ic_search_tire_loader from "../img/ic_tire_loader.png";
import ic_checked from "../img/ic_checked.png";
import ic_unchecked from "../img/ic_unchecked.png";
import Job_creation_success_popup from "../components/Job_creation_success_popup";
import Create_customer_popup from "./Create_customer_popup";
import Fleet_registration_popup from "./Fleet_registration_popup";
import { useNavigate } from "react-router-dom";
import ic_refresh from "../img/ic_refresh.png";

function CreateNewJob() {

    const [isCallingItemSearchAPI, setIsCallingItemSearchAPI] = useState(false);
    const navigate = useNavigate();
    const [addFleetPopup, setAddFleetPopup] = useState(false);
    const [createCustomerPopup, setCreateCustomerPopup] = useState(false);
    const [successfulJobCreationPopup, setSuccessfulJobCreationPopup] = useState(false);
    const [arrayOfCustomerPoints, setArrayOfCustomerPoints] = useState(null);
    const [issCallingApiCustomerPoints, setIsCallingApiCustomerPoints] = useState(null);
    const [isCallingApiRedeemableServiceList, setIsCallingApiRedeemableServiceList] = useState(null);
    const [arrayOfRedeemableServiceList, setArrayOfRedeemableServiceList] = useState(null)
    const currentTemplateRowId = useRef();
    const [issCallingApiServiceListDropDown, setIsCallingApiServiceListDropDown] = useState(false);
    const [arrayOfServiceListDropDown, setArrayOfServiceListDropDown] = useState(null);
    const [arrayOfSearchResultsCarList, setArrayOfSearchResultsCarList] = useState(null)
    const [searchTextState, setSearchTextState] = useState("");
    const mobileNumberSearchBoxRef = useRef();
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [isCallingApi, setIsCallingApi] = useState(false);
    const [isCallingCustomerCarListApi, setIsCallingCustomerCarListApi] = useState(false);
    const [showHideSearchListBox, setShowHideSearchListBox] = useState(false);
    const [arrayOfSearchResults, setArrayOfSearchResults] = useState();

    const [timeIntervalServiceListAPI, setTimeIntervalServiceListAPI] = useState(null);


    const objectToSendToAPI = {
        user_name: "",
        account_number: "",
        mobile_number: "",
        customer_name: "",
        customer_address: "",
        loyalty_category: "",
        car_number: "",
        chassis_no: "",
        model: "",
        make: "",
        year: "",
        odometer_reading: "",
        fuel_meter_reading: 0,
        technicians_assigned: "",
        service_package: "",
        points_available: 0,
        points_earned: 0,
        points_redeemed: 0,
        total_amt: 0,
        service_list: []
    }

    let templateOfService = {
        table_row_template_id: objectToSendToAPI.service_list.length + 1,
        table_row_template_code: "",
        table_row_template_code_typed: "",
        table_row_template_description: "",
        table_row_template_group: "",
        table_row_template_unit: "",
        table_row_template_qty: 1,
        table_row_template_price: 0,
        table_row_template_points: 0,
        table_row_template_amount: 0,
    };

    const [arrayOfSelectedServicesState, setArrayOfSelectedServicesState] = useState([templateOfService]);

    const [objectToSendToAPIState, setObjectToSendToAPIState] = useState(objectToSendToAPI);

    useEffect(() => {

        console.log("arrayOfSelectedServicesState is ", arrayOfSelectedServicesState)
        setObjectToSendToAPIState({ ...objectToSendToAPIState, service_list: arrayOfSelectedServicesState })

    }, [arrayOfSelectedServicesState])

    const [stageCardOpenState, setStageCardOpenState] = useState(
        [{ stage_card_open_state: true }, { stage_card_open_state: true }, { stage_card_open_state: true }])

    const toggleCardVisibility = (stage_index) => {

        let newArrayAfterClick = stageCardOpenState.map((item, index) => {
            if (stage_index == index) {
                return {
                    stage_card_open_state: !stageCardOpenState[stage_index].stage_card_open_state
                }
            } else {
                return item
            }

        })

        setStageCardOpenState(newArrayAfterClick);

    }



    const setFuelReading = (fuelReading) => {
        console.log("setfuelreading clicked ", fuelReading);
        setObjectToSendToAPIState({ ...objectToSendToAPIState, fuel_meter_reading: fuelReading })
    }

    const setOdometerReading = (e) => {
        setObjectToSendToAPIState({ ...objectToSendToAPIState, odometer_reading: e.target.value })
    }

    const [assignButtonClickedState, setAssignButtonClickedState] = useState(false);

    const showHideAssignedPopup = () => {
        setAssignButtonClickedState(prev => !prev)
    }

    const clickedOnCloseButton = () => {
        showHideAssignedPopup();
    }

    const clickedOnSaveButton = (technicianListFromPopup) => {

        setTechnicianListState(technicianListFromPopup);
        setObjectToSendToAPIState({ ...objectToSendToAPIState, technicians_assigned: technicianListFromPopup })

        showHideAssignedPopup();
    }

    const clickedOnCloseConfirmPopupButton = () => {
        showHideConfirmPopup();
    }

    const closePopupAfterSuccessfulJobCreation = () => {
        showHideSuccessfulJobCreationPopup();
        navigate("/home", { replace: true })
    }

    const closePopupAfterSuccessfulUserCreation = () => {
        showHideCreateNewUserPopup()
        showHideSuccessMessage("successfully created user ");

    }

    const closePopupUserCreation = () => {
        showHideCreateNewUserPopup()
    }

    const closePopupAddFleet = () => {
        showHideAddFleetPopup();
    }

    const closePopupAfterSuccessfulFleetCreation = () => {
        showHideAddFleetPopup();
        showHideSuccessMessage("Successfully added fleet ");
    }

    const [technicianListState, setTechnicianListState] = useState([]);

    const [selectCarDropDownState, setSelectCarDropDownState] = useState(false);

    const clickedOnSelectCar = () => {

        setSelectCarDropDownState(prev => !prev);
    }

    const [confirmJobState, setConfirmJobState] = useState(false);

    const clickedOnContinue = () => {

        // check if 
        // 1. customer is selected 
        // 2. car number plate is selected
        // 3. Fuel meter Odometr

        // 3. atleast 1 item is present in the service list array

        //showHideConfirmPopup();

        if (objectToSendToAPIState.account_number.length == 0) {
            setErrorMessage("please select a customer ")
        } else if (objectToSendToAPIState.car_number.length == 0) {
            setErrorMessage("please select car ")
        } else if (objectToSendToAPIState.odometer_reading.length == 0) {
            setErrorMessage("please enter odometer reading")
        } else if (objectToSendToAPIState.fuel_meter_reading == 0) {
            setErrorMessage("please select fuel meter reading")
        } else if (objectToSendToAPIState.technicians_assigned.length == 0) {
            setErrorMessage("please select technician")
        } else if (objectToSendToAPIState.service_list.length == 0) {
            setErrorMessage("please add atleast 1 service")
        } else if (objectToSendToAPIState.service_list.length > 0) {

            let indexOfRowWithEmptyCode = objectToSendToAPIState.service_list.findIndex((item) => {
                return item.table_row_template_code == ""
            })
            if (indexOfRowWithEmptyCode >= 0) {
                setErrorMessage(`please add service in row ${indexOfRowWithEmptyCode + 1} `)
            } else {
                showHideConfirmPopup();
            }

        }

    }
    const showHideConfirmPopup = () => {
        setConfirmJobState(prev => !prev);
    }

    const showHideSuccessfulJobCreationPopup = () => {
        setSuccessfulJobCreationPopup(prev => !prev);
    }

    const showHideCreateNewUserPopup = () => {
        setCreateCustomerPopup(prev => !prev)
    }

    const showHideAddFleetPopup = () => {
        setAddFleetPopup(prev => !prev)
    }

    const clickedOnAddFleet = () => {

        if (objectToSendToAPIState.account_number != 0) {
            setAddFleetPopup(prev => !prev)
        }
        else {
            setErrorMessage("Please search cusomer, then add fleet")
        }
    }

    const showHideSuccessMessage = (messageFromPopup) => {
        setSuccessMessage(messageFromPopup);
    }

    let timeInterval = null;

    const callCustomerSearchApi = (searchingText) => {

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/mobile/${searchingText}`).then((res) => {

            setTimeout(() => {
                setIsCallingApi(false);
            }, 1000)


            console.log(" res is ", res);
            setArrayOfSearchResults(res.data.jsont);
        }).catch(err => {
            setTimeout(() => {
                setIsCallingApi(false);
            }, 1000)
            console.log("err is ", err)
        })

    }

    const handleMobileNumberSearch = (e) => {

        clearInterval(timeInterval);

        timeInterval = setTimeout(() => {
            if (e.target.value.length > 0) {

                console.log(" searchtext changed is", e.target.value);
                if (timeInterval) {
                    console.log("timer is not null we are clearing it")
                    clearInterval(timeInterval);
                }
                setShowHideSearchListBox(true);
                setIsCallingApi(true);
                callCustomerSearchApi(e.target.value);
                setSearchTextState(e.target.value);

            } else {
                setSearchTextState("");
                setShowHideSearchListBox(false);
            }
        }, 500)
    }

    const clickedItemFromSearchList = (ind) => {
        console.log("clicked on ", ind);
        mobileNumberSearchBoxRef.current.value = "";
        setShowHideSearchListBox(false);
        if (arrayOfSearchResults != null) {

            setObjectToSendToAPIState({
                ...objectToSendToAPIState,
                customer_name: arrayOfSearchResults[ind].Customer,
                mobile_number: arrayOfSearchResults[ind].Mobile_No,
                account_number: arrayOfSearchResults[ind].Account,
                customer_address: arrayOfSearchResults[ind].Address,
                car_number: "",
                chassis_no: "",
                make: "",
                model: "",
                year: ""
            })

        }


        getCarListOfCustomer(arrayOfSearchResults[ind].Account);

        callGetRedeemableServiceList(arrayOfSearchResults[ind].Account);

        callGetPointsAndPackagesOfCustomer(arrayOfSearchResults[ind].Account);
    }

    const removeMobileNumberSearch = () => {
        mobileNumberSearchBoxRef.current.value = "";
        setSearchTextState("");
        setShowHideSearchListBox(false);
        setArrayOfSearchResults([]);

    }

    const getCarListOfCustomer = (user_account_number) => {

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/custfleet/${user_account_number}`).then((res) => {
            setIsCallingCustomerCarListApi(false);
            console.log("car list res is ", res);
            setArrayOfSearchResultsCarList(res.data.jsont);
        }).catch(err => {
            console.log("err is ", err)
        })
    }

    const clickedOnNumberPlate = (numberPlate, chassisNumber, modelFromClick, makeFromClick, yearFromClick) => {
        setObjectToSendToAPIState({
            ...objectToSendToAPIState,
            car_number: numberPlate,
            chassis_no: chassisNumber,
            make: makeFromClick,
            model: modelFromClick,
            year: yearFromClick
        });
        setSelectCarDropDownState(prev => !prev);
    }

    const callGetServiceListAPI = (serviceItemSearchText) => {

        setIsCallingItemSearchAPI(true);

        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/item_search/${serviceItemSearchText}`).then((res) => {

            setIsCallingApiServiceListDropDown(false);

            console.log(" res is ", res);
            setArrayOfServiceListDropDown(res.data.jsont);

            setIsCallingItemSearchAPI(false)
        }).catch(err => {
            console.log("err is ", err)
            setIsCallingItemSearchAPI(false)
        })
    }

    const callGetRedeemableServiceList = (userAccountNumber) => {
        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/redeemlist/${userAccountNumber}`).then((res) => {

            setIsCallingApiRedeemableServiceList(false);

            console.log(" res is ", res);
            setArrayOfRedeemableServiceList(res.data.jsont);
        }).catch(err => {
            console.log("err is ", err)
        })
    }

    const callGetPointsAndPackagesOfCustomer = (userAccountNumber) => {
        axios.get(`${process.env.REACT_APP_BACK_END_BASE_URL}/Search_Customer/custpoints/${userAccountNumber}`).then((res) => {

            setIsCallingApiCustomerPoints(false);

            console.log("points res is ", res);
            setArrayOfCustomerPoints(res.data.jsont);

            setObjectToSendToAPIState(prev => ({ ...prev, points_available: res.data.jsont[0].Pnts_available, loyalty_category: res.data.jsont[0].Loyalty_Categ }))

        }).catch(err => {
            console.log("err is ", err)
        })
    }

    const handleServiceListInput = (e, templateRowId) => {

        // console.log(" handleServiceListInput is templateRowId ", e.target.value, templateRowId)

        currentTemplateRowId.current = templateRowId;

        let newMappedArray = arrayOfSelectedServicesState.map((itemFilter) => {

            if (itemFilter.table_row_template_id == templateRowId) {
                return { ...itemFilter, table_row_template_code_typed: e.target.value }
            } else {
                return itemFilter
            }
        })

        setArrayOfSelectedServicesState(newMappedArray);

        clearInterval(timeIntervalServiceListAPI);

        setTimeIntervalServiceListAPI(

            setTimeout(() => {

                if (e.target.value.length > 0) {
                    if (timeIntervalServiceListAPI) {
                        console.log("timer is not null we are clearing it")
                        clearInterval(timeIntervalServiceListAPI);
                    }
                    callGetServiceListAPI(e.target.value)
                } else {
                    setArrayOfServiceListDropDown([]);
                }

            }, 500)
        )


    }

    const handleServiceListInputQty = (e, templateRowId, index) => {

        //console.log(" handleServiceListInputQty + templateRowId ", e.target.value, templateRowId)

        currentTemplateRowId.current = templateRowId;


        let newMappedArray = arrayOfSelectedServicesState.map((itemFilter) => {

            if (itemFilter.table_row_template_id == templateRowId) {

                if (arrayOfSelectedServicesState[index].table_row_template_unit != "FOC") {
                    return {
                        ...itemFilter,
                        table_row_template_qty: e.target.value,
                        table_row_template_amount: parseInt(e.target.value) * itemFilter.table_row_template_price
                    }
                } else {
                    return {
                        ...itemFilter,
                        table_row_template_qty: e.target.value,
                    }
                }
            } else {
                return itemFilter
            }
        })

        setArrayOfSelectedServicesState(newMappedArray);



    }

    const sendServiceListitemClickToparent = (indexOfSearchListofRowFromChild, item) => {
        console.log("clicked on service List ", indexOfSearchListofRowFromChild, item)

        /////
        // check if item present in array list if yes show error message 
        // 
        // else add point to point_to_redeem state
        /////

        let indexInPursuit = arrayOfSelectedServicesState.findIndex((itemFilter) => {
            return itemFilter.table_row_template_code == item.Code
        });

        if (indexInPursuit >= 0) {
            setErrorMessage("Item already present in list")

            if (item.unit == "FOC") {

                setObjectToSendToAPIState({
                    ...objectToSendToAPIState,
                    points_redeemed: objectToSendToAPIState.points_redeemed - item.Points
                })
            } else {

                setObjectToSendToAPIState({
                    ...objectToSendToAPIState,
                    points_earned: objectToSendToAPIState.points_earned - item.Points
                })
            }

            // to make full code appear in code typing field do this
            let newMappedArray = arrayOfSelectedServicesState.map((itemFilter, index) => {

                if (index == indexOfSearchListofRowFromChild) {
                    return {
                        ...itemFilter,
                        table_row_template_code_typed: item.Code,
                    }
                } else {
                    return itemFilter
                }
            })
            setArrayOfSelectedServicesState(newMappedArray);
            setArrayOfServiceListDropDown([]);
        }
        else {

            setObjectToSendToAPIState({ ...objectToSendToAPIState, points_earned: objectToSendToAPIState.points_earned + item.Points })

            let newMappedArray = arrayOfSelectedServicesState.map((itemFilter, index) => {

                if (index == indexOfSearchListofRowFromChild) {
                    return {
                        ...itemFilter,
                        table_row_template_code: item.Code,
                        table_row_template_code_typed: item.Code,
                        table_row_template_description: item.Description,
                        table_row_template_points: item.Points,
                        table_row_template_unit: item.unit,
                        table_row_template_price: item.price,
                        table_row_template_amount: item.price * parseInt(itemFilter.table_row_template_qty),
                    }
                } else {
                    return itemFilter
                }
            })
            setArrayOfSelectedServicesState(newMappedArray);
            setArrayOfServiceListDropDown([]);
        }

    }

    const addServiceButtonClicked = () => {

        let newlyAddedItemOnAddServiceClick = { ...templateOfService, table_row_template_id: arrayOfSelectedServicesState.length + 1 };
        setArrayOfSelectedServicesState([...arrayOfSelectedServicesState, newlyAddedItemOnAddServiceClick])
    }

    const getSwitchCasePoints = () => {
        if (arrayOfCustomerPoints != null) {
            switch (arrayOfCustomerPoints[0].Loyalty_Categ) {
                case "BRONZE": return <span>BRONZE</span>
                case "SILVER": return <span>SILVER</span>
                case "GOLD": return <span>GOLD</span>
                case "PLATINUM": return <span>PLATINUM</span>
            }
        } else {
            return <span>No Package Found</span>
        }
    }

    const getSwitchCasePointsImage = () => {
        if (arrayOfCustomerPoints != null) {
            switch (arrayOfCustomerPoints[0].Loyalty_Categ) {
                case "BRONZE": return BRONZ_NEW
                case "SILVER": return SILVER_NEW
                case "GOLD": return GOLD_NEW
                case "PLATINUM": return PLATINUM_NEW
            }
        }
    }

    const changeToggleStatusOfRedeemableServiceList = (indexFromClick) => {

        console.log("indexFromClick Redeemable list is", indexFromClick)

        let newArrayAfterPickingRedeemableServiceList = arrayOfRedeemableServiceList.map((item, index) => {
            if (indexFromClick == index) {
                return {
                    ...item, selected_state: !item.selected_state
                }
            } else {
                return item;
            }

        })

        console.log("changeToggleStatusOfRedeemableServiceList newArray is ", newArrayAfterPickingRedeemableServiceList)



        /////
        /// above operations to set check uncheck of redeemable service list
        /// below operations for total service list
        /////

        let indexInPursuit = arrayOfSelectedServicesState.findIndex((item) => {
            return item.table_row_template_code == arrayOfRedeemableServiceList[indexFromClick].SERVICE_CODE
        });

        if (indexInPursuit >= 0) {

            if (arrayOfSelectedServicesState[indexInPursuit].table_row_template_unit != "FOC") {

                // if there exists a row with same code but it is a normal service , remove it and 
                // push this redeemable item row
                if (objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS <= objectToSendToAPIState.points_available) {

                    console.log("points inside limit ", objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS)



                    setObjectToSendToAPIState({ ...objectToSendToAPIState, points_redeemed: objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS })

                    // remove normal item using filter then in that filtered array spred the new object from redeemable list
                    // then settoServiceListState 

                    let resultArrayAfterTemplateRowIdModification = arrayOfSelectedServicesState.filter((item, index) => {
                        return index != indexInPursuit;
                    }).map((item, index) => {
                        return { ...item, table_row_template_id: index + 1 }
                    })

                    let objectToBeInserted = {
                        table_row_template_id: resultArrayAfterTemplateRowIdModification.length + 1,
                        table_row_template_code: arrayOfRedeemableServiceList[indexFromClick].SERVICE_CODE,
                        table_row_template_code_typed: arrayOfRedeemableServiceList[indexFromClick].SERVICE_CODE,
                        table_row_template_description: arrayOfRedeemableServiceList[indexFromClick].DESCRIPTION,
                        table_row_template_group: "",
                        table_row_template_unit: "FOC",
                        table_row_template_qty: 1,
                        table_row_template_price: 0,
                        table_row_template_points: arrayOfRedeemableServiceList[indexFromClick].POINTS,
                        table_row_template_amount: 0
                    }

                    setArrayOfSelectedServicesState([...resultArrayAfterTemplateRowIdModification, objectToBeInserted]);
                } else {
                    console.log("points exceeded available limit ", objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS)
                }

            } else {

                    setObjectToSendToAPIState({
                        ...objectToSendToAPIState,
                        points_redeemed: objectToSendToAPIState.points_redeemed - arrayOfRedeemableServiceList[indexFromClick].Points
                    })

                let resultArrayAfterTemplateRowIdModification = arrayOfSelectedServicesState.filter((item, index) => {
                    return index != indexInPursuit;
                }).map((item, index) => {
                    return { ...item, table_row_template_id: index + 1 }
                })

                setArrayOfSelectedServicesState(resultArrayAfterTemplateRowIdModification)
            }


        } else {

            //////
            // first check if this selected item's point + points_to_be_redeemed exceeds points
            // available , if exceeds graceful exit
            // else push item and do calculation points_to_be_redeemed = item's_point + points_to_be_redeemed
            // and set state
            //////    

            if (objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS <= objectToSendToAPIState.points_available) {

                setArrayOfRedeemableServiceList(newArrayAfterPickingRedeemableServiceList)

                console.log("points inside limit ", objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS)

                let objectToBeInserted = {
                    table_row_template_id: objectToSendToAPIState.service_list.length + 1,
                    table_row_template_code: arrayOfRedeemableServiceList[indexFromClick].SERVICE_CODE,
                    table_row_template_code_typed: arrayOfRedeemableServiceList[indexFromClick].SERVICE_CODE,
                    table_row_template_description: arrayOfRedeemableServiceList[indexFromClick].DESCRIPTION,
                    table_row_template_group: "",
                    table_row_template_unit: "FOC",
                    table_row_template_qty: 1,
                    table_row_template_price: 0,
                    table_row_template_points: arrayOfRedeemableServiceList[indexFromClick].POINTS,
                    table_row_template_amount: 0
                }

                setObjectToSendToAPIState({ ...objectToSendToAPIState, points_redeemed: objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS })
                setArrayOfSelectedServicesState(prev => ([...prev, objectToBeInserted]));
            } else {
                console.log("points exceeded available limit ", objectToSendToAPIState.points_redeemed + arrayOfRedeemableServiceList[indexFromClick].POINTS)

                setErrorMessage("Cannot add this service, points redeemed exceeded Availbale points ")
            }
        }
    }

    const deleteTemplateRowFromServiceList = (indexOfRowToBeRemoved) => {

        if (arrayOfSelectedServicesState[indexOfRowToBeRemoved].table_row_template_unit == "FOC") {
            setObjectToSendToAPIState({ ...objectToSendToAPIState, points_redeemed: objectToSendToAPIState.points_redeemed - arrayOfSelectedServicesState[indexOfRowToBeRemoved].table_row_template_points })
        }else{
            setObjectToSendToAPIState({ ...objectToSendToAPIState, points_earned: objectToSendToAPIState.points_earned - arrayOfSelectedServicesState[indexOfRowToBeRemoved].table_row_template_points })
        }

        let resultArrayAfterTemplateRowIdModification = arrayOfSelectedServicesState.filter((item, index) => {
            return index != indexOfRowToBeRemoved;
        }).map((item, index) => {
            return { ...item, table_row_template_id: index + 1 }
        })


        setArrayOfSelectedServicesState(resultArrayAfterTemplateRowIdModification)
    }


    const clickedOnRefreshCarList = (userAccountNumber) => {

        if (userAccountNumber != null) {
            if (userAccountNumber.length > 0) {
                getCarListOfCustomer(userAccountNumber)
            } else {
                setErrorMessage("Please select customer")
            }
        } else {
            setErrorMessage("Please select customer")
        }

    }


    return (

        <div className="CreateNewJob-root-container page_background">

            {
                errorMessage.length > 0 &&
                <div className="CreateNewJob-error-message-container p-2">

                    <label className="CreateNewJob-error-message">{errorMessage}</label>
                    <span className="common_small_black_button" onClick={() => setErrorMessage("")}>Ok</span>
                </div>
            }

            {
                successMessage.length > 0 &&
                <div className="CreateNewJob-success-message-container p-2">
                    <label className="CreateNewJob-success-message">{successMessage}</label>
                    <span className="common_small_black_button" onClick={() => setSuccessMessage("")}>Ok</span>
                </div>
            }

            <Header />

            <div className="CreateNewJob-inner-container ">

                {/* first card */}
                <div className="CreateNewJob-single-card">

                    <div className="CreateNewJob-card-container-stage-header">
                        <label>Select Vehicle</label>
                        <img className="CreateNewJob-toggle-card-open-state" src={stageCardOpenState[0].stage_card_open_state ? ic_collapse_arrow : ic_expand_arrow} onClick={() => toggleCardVisibility(0)} />
                    </div>
                    <div id="CreateNewJob_show_hide_container" className={stageCardOpenState[0].stage_card_open_state ? "CreateNewJob_show_card_body" : "CreateNewJob_hide_card_body"}>
                        <div className="CreateNewJob-card-container-stage-body CreateNewJob-mobile-number-select-car-container">
                            <div className="CreateNewJob-searchbox-total-container">
                                <div className="CreateNewJob-search-box-and-list-container">
                                    <div className="CreateNewJob-searchbox-input-close-container">
                                        <input autoComplete="off" ref={mobileNumberSearchBoxRef} onChange={(e) => handleMobileNumberSearch(e)} className="common_input" type="number" name="input_customer_mobile_number" placeholder="Enter mobile number" />
                                        {
                                            searchTextState.length > 0 ?
                                                <img className="CreateNewJob-clear-search-close-icon" onClick={() => removeMobileNumberSearch()} src={ic_clear_search_box} />
                                                :
                                                null
                                        }
                                    </div>
                                    {showHideSearchListBox &&

                                        <div className="CustomerDetailsPage_SearchResultListContainer">

                                            {isCallingApi && <div className="CustomerDetailsPage-searching-loader-text-div"><span className="CustomerDetailsPage_search_span"><img className="rotate me-2" src={ic_search_tire_loader} />Searching Customer...</span></div>}
                                            {

                                                arrayOfSearchResults != null ?
                                                    arrayOfSearchResults.length > 0 ?
                                                        <table className="CustomerDetailsPage_SearchResultListContainer-table">
                                                            <thead>
                                                                <tr>

                                                                    <th><div>Name</div></th>
                                                                    <th><div>Mobile</div></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                {arrayOfSearchResults != null ?
                                                                    arrayOfSearchResults.length > 0 ?
                                                                        arrayOfSearchResults.map((item, index) => {
                                                                            return (<tr key={item.Code} id={item.Code} className="CustomerDetailsPage_SearchResultListContainer_single_list_item" onClick={() => clickedItemFromSearchList(index)} >

                                                                                <td>
                                                                                    <div>
                                                                                        {item.Customer}
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    <div>
                                                                                        {item.Mobile_No}

                                                                                    </div>
                                                                                </td>

                                                                            </tr>)
                                                                        })
                                                                        : null
                                                                    : null}

                                                            </tbody>
                                                        </table>
                                                        : null
                                                    : <div>

                                                        <label className="CreateNewJob-customer-not-found-label m-2">Customer not found <button className="common_small_black_button ms-2" onClick={() => showHideCreateNewUserPopup()}>Create Now</button></label>
                                                    </div>

                                            }

                                        </div>
                                    }
                                </div>
                                <div className="CreateNewJob-customer-personal-and-car-details">
                                    <div className="CreateNewJob-customer-label-and-values">
                                        <label className="common_style_label">Customer Name</label>
                                        <label className="common_style_value">{objectToSendToAPIState.customer_name.length > 0 ? objectToSendToAPIState.customer_name : "---"}</label>
                                    </div>
                                    <div className="CreateNewJob-customer-label-and-values">
                                        <label className="common_style_label">Mobile Number</label>
                                        <label className="common_style_value">{objectToSendToAPIState.mobile_number.length > 0 ? objectToSendToAPIState.mobile_number : "---"}</label>
                                    </div>
                                    <div className="CreateNewJob-customer-label-and-values">
                                        <label className="common_style_label">Address</label>
                                        <label className="common_style_value">{objectToSendToAPIState.customer_address.length > 0 ? objectToSendToAPIState.customer_address : "---"}</label>
                                    </div>
                                </div>
                            </div>
                            <div className="CreateNewJob-select-car-dropdown-and-value">
                                <label onClick={() => clickedOnSelectCar()} className="CreateNewJob-card-container-select-car-dropdown">
                                    <span>Select Car</span>
                                    <img src={ic_dropdown_select_car} className="ms-3" />
                                </label>
                                <button className="common_small_black_button ms-2" onClick={() => clickedOnAddFleet()}>Add fleet</button>
                                <div className="CreateNewJob-customer-label-and-values CreateNewJob-car-number-value-container">
                                    <label className="common_style_label">Car Number</label>
                                    <label className="common_style_value">{objectToSendToAPIState.car_number.length > 0 ? objectToSendToAPIState.car_number : "--"}</label>
                                </div>

                                {
                                    selectCarDropDownState &&

                                    <div className="CreateNewJob-car-dropdown-container">
                                        <div onClick={() => clickedOnRefreshCarList(objectToSendToAPIState.account_number)} className="CreateNewJob-refresh-container">
                                            <img src={ic_refresh} />
                                            <label>Refresh</label>
                                        </div>
                                        {
                                            arrayOfSearchResultsCarList != null ?
                                                arrayOfSearchResultsCarList.map((item) => {
                                                    return (
                                                        <div onClick={() => clickedOnNumberPlate(item.PLATE_NO, item.CHASSIS_NO, item.MODEL, item.MAKE, item.YEAR)} className="CreateNewJob-car-dropdown-list-item">{item.PLATE_NO}</div>
                                                    )

                                                })
                                                :
                                                null
                                        }


                                    </div>
                                }

                            </div>
                        </div>
                    </div>

                </div>

                {/* second card */}

                <div className="CreateNewJob-single-card mt-4">

                    <div className="CreateNewJob-card-container-stage-header">
                        <label>Vehicle Inspection</label>
                        <img className="CreateNewJob-toggle-card-open-state" src={stageCardOpenState[1].stage_card_open_state ? ic_collapse_arrow : ic_expand_arrow} onClick={() => toggleCardVisibility(1)} />
                    </div>
                    <div id="CreateNewJob_show_hide_container" className={stageCardOpenState[1].stage_card_open_state ? "CreateNewJob_show_card_body" : "CreateNewJob_hide_card_body"}>
                        <div className="CreateNewJob-card-container-stage-body">

                            <div>
                                <label className="common_style_label">Enter Odometer reading (km)</label>
                                <div className="mt-2">
                                    <input autoComplete="off" className="common_input" type="number" name="input_car_odometer_reading" onChange={(e) => setOdometerReading(e)} />
                                </div>
                            </div>
                            <div className="CreateNewJob-fuel-meter-reading-container">
                                <label className="common_style_label">Enter Fuel Meter reading</label>
                                <div className="mt-2">

                                    <label onClick={() => setFuelReading(0.25)}
                                        className={
                                            objectToSendToAPIState.fuel_meter_reading == 0.25
                                                ? "CreateNewJob-fuel-reading-button-selected mx-1" : "CreateNewJob-fuel-reading-button mx-1"}>
                                        <span className={
                                            objectToSendToAPIState.fuel_meter_reading == 0.25
                                                ? "CreateNewJob-radio-button-selected me-2" : "CreateNewJob-radio-button-normal me-2"}></span>1/4</label>
                                    <label onClick={() => setFuelReading(0.50)} className={
                                        objectToSendToAPIState.fuel_meter_reading == 0.50
                                            ? "CreateNewJob-fuel-reading-button-selected  mx-1" : "CreateNewJob-fuel-reading-button mx-1"}>
                                        <span className={
                                            objectToSendToAPIState.fuel_meter_reading == 0.50
                                                ? "CreateNewJob-radio-button-selected me-2" : "CreateNewJob-radio-button-normal me-2"}></span>1/2</label>
                                    <label onClick={() => setFuelReading(0.75)} className={
                                        objectToSendToAPIState.fuel_meter_reading == 0.75
                                            ? "CreateNewJob-fuel-reading-button-selected mx-1" : "CreateNewJob-fuel-reading-button mx-1"}><span className={
                                                objectToSendToAPIState.fuel_meter_reading == 0.75
                                                    ? "CreateNewJob-radio-button-selected me-2" : "CreateNewJob-radio-button-normal me-2"}></span>3/4</label>

                                    <label onClick={() => setFuelReading(1)} className={
                                        objectToSendToAPIState.fuel_meter_reading == 1
                                            ? "CreateNewJob-fuel-reading-button-selected mx-1" : "CreateNewJob-fuel-reading-button mx-1"}><span className={
                                                objectToSendToAPIState.fuel_meter_reading == 1
                                                    ? "CreateNewJob-radio-button-selected me-2" : "CreateNewJob-radio-button-normal me-2"}></span>Full tank</label>
                                </div>
                            </div>
                        </div>
                        <div className="CreateNewJob-technicians-container">
                            <div>
                                <label className="common_style_label">Technicians Assigned</label>
                                <button onClick={() => showHideAssignedPopup()} className="common_small_black_button ms-3">Assign</button>
                            </div>
                            <div className="CreateNewJob-technicians-assigned-list-wrapper"><p className="CreateNewJob-technicians-assigned-list-container mt-2">
                                {
                                    technicianListState.map((item) => {
                                        return (
                                            <label>{item.Technician},</label>
                                        )

                                    })
                                }</p></div>
                        </div>
                    </div>
                </div>

                {/* third card */}

                <div className="CreateNewJob-single-card mt-4">

                    <div className="CreateNewJob-card-container-stage-header">
                        <label>Add Service</label>

                        <img className="CreateNewJob-toggle-card-open-state" src={stageCardOpenState[2].stage_card_open_state ? ic_collapse_arrow : ic_expand_arrow} onClick={() => toggleCardVisibility(2)} />
                    </div>

                    <div id="CreateNewJob_show_hide_container" className={stageCardOpenState[2].stage_card_open_state ? "CreateNewJob_show_card_body" : "CreateNewJob_hide_card_body"}>
                        <div className="CreateNewJob-card-container-stage-body">


                            {
                                // LOYALTY_PROGRAM 
                                process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                    <div className="CreateNewJob-card-container-point-slab">
                                        <div>
                                            <label className="CreateNewJob-points-label">Points <br className="CreateNewJob-line-break" /> Available</label>
                                            <label className="ms-2 CreateNewJob-point">{objectToSendToAPIState.points_available}</label>
                                        </div>
                                        <div>
                                            <label className="CreateNewJob-points-label">Points  <br className="CreateNewJob-line-break" /> Redeemed</label>
                                            <label className="ms-2 CreateNewJob-point">{objectToSendToAPIState.points_redeemed}</label>
                                        </div>
                                        <span className="CreateNewJob-card-container-point-slab-package-icon-container">
                                            <img className="CreateNewJob-package-image" src={getSwitchCasePointsImage()} />
                                            <span><span className="CreateNewJob-package-span">{getSwitchCasePoints()}</span></span>
                                        </span>
                                    </div>
                                    :
                                    null
                            }

                        </div>
                        <div className="CreateNewJob-service-list-table-container-wrapper pb-2">
                            <div className="CreateNewJob-service-list-table-container">
                                <table className="CreateNewJob-service-list-table">
                                    <thead>
                                        <tr>
                                            <th><div className="CreateNewJob-sl-no-container">Sl. No.</div></th>
                                            <th className="CreateNewJob_service_code_th"><div>Service Code</div></th>
                                            <th><div>Description</div></th>
                                            {
                                                // LOYALTY_PROGRAM
                                                process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                    <th><div>Points</div></th>
                                                    :
                                                    null
                                            }
                                            <th><div>Unit</div></th>
                                            <th><div>Qty</div></th>
                                            <th><div>Price</div></th>
                                            <th><div>Amount</div></th>
                                            <th><div className="CreateNewJob-delete-button-container ">Remove</div></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {
                                            arrayOfSelectedServicesState.map((item, index) => {
                                                return (
                                                    <tr className="CreateNewJob-service-list-table-single-row">
                                                        <td><div>{item.table_row_template_id}</div></td>
                                                        <td>
                                                            <div className="CreateNewJob_Add_service_popup_parent_container">

                                                                <input autoComplete="off" className="CreateNewJob_Add_service_popup_type_box" name="table_row_template_code"
                                                                    value={item.table_row_template_code_typed}
                                                                    onChange={(e) => handleServiceListInput(e, item.table_row_template_id)} />

                                                                {
                                                                    isCallingItemSearchAPI ?
                                                                        currentTemplateRowId.current == item.table_row_template_id ?
                                                                            <div className="CreateNewJob_horizontal_loader_container ">
                                                                                <span className="loader"></span>
                                                                            </div>
                                                                            :
                                                                            null
                                                                        :
                                                                        null
                                                                }


                                                                {
                                                                    arrayOfServiceListDropDown != null ?
                                                                        arrayOfServiceListDropDown.length > 0 ?
                                                                            currentTemplateRowId.current == item.table_row_template_id ?
                                                                                < Add_service_popup idOfRow={index} arrayOfServiceListDropDown={arrayOfServiceListDropDown} sendServiceListitemClickToparent={sendServiceListitemClickToparent} />
                                                                                :
                                                                                null
                                                                            :
                                                                            null
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </td>
                                                        <td><div className="CreateNewJob-service-table-body-description-column">{item.table_row_template_description}</div></td>
                                                        {
                                                            // LOYALTY_PROGRAM
                                                            process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                                                <td><div>{item.table_row_template_points}</div></td>
                                                                :
                                                                null
                                                        }
                                                        <td><div>{item.table_row_template_unit}</div></td>
                                                        <td>
                                                            <div>
                                                                <input autoComplete="off" className="CreateNewJob_Add_service_qty_box" name="table_row_template_code"
                                                                    value={item.table_row_template_qty}
                                                                    onChange={(e) => handleServiceListInputQty(e, item.table_row_template_id, index)} />
                                                            </div>
                                                        </td>
                                                        <td><div>{item.table_row_template_price}</div></td>
                                                        <td><div>{item.table_row_template_amount}</div></td>
                                                        <td><div><img className="CreateNewJob-remove-service-from-table-image" src={ic_trash} onClick={() => { deleteTemplateRowFromServiceList(index) }} /></div></td>
                                                    </tr>
                                                )
                                            })
                                        }


                                    </tbody>
                                </table>
                            </div>

                            {
                                // LOYALTY_PROGRAM
                                process.env.REACT_APP_ENABLE_LOYALTY_PROGRAM == "true" ?
                                    <div className="CreateNewJob-service-list-table-container CreateNewJob-Redeemable-list-table-container mt-2">
                                        {
                                            arrayOfRedeemableServiceList != null ?

                                                arrayOfRedeemableServiceList.length > 0 ?

                                                    <table className="CreateNewJob-service-list-table">
                                                        <thead>
                                                            <tr>
                                                                <th></th>
                                                                <th><div className="CreateNewJob-sl-no-container">Sl. No.</div></th>
                                                                <th className="CreateNewJob_service_code_th"><div>Service Code</div></th>
                                                                <th><div>Description</div></th>
                                                                <th><div>Points(Redeem)</div></th>
                                                                <th><div>Unit</div></th>
                                                                <th><div>Qty</div></th>
                                                                <th><div>Price</div></th>
                                                                <th><div>Amount</div></th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {
                                                                arrayOfRedeemableServiceList.map((item, index) => {
                                                                    return (
                                                                        <tr className="CreateNewJob-service-list-table-single-row" onClick={() => changeToggleStatusOfRedeemableServiceList(index)}>
                                                                            <td>
                                                                                <div>
                                                                                    <img className="Technician-list-popup-checkbox" src={item.selected_state ? ic_checked : ic_unchecked} />
                                                                                </div>
                                                                            </td>
                                                                            <td><div>{index + 1}</div></td>
                                                                            <td>
                                                                                <div className="CreateNewJob_Add_service_popup_parent_container">

                                                                                    {item.SERVICE_CODE}


                                                                                </div>
                                                                            </td>
                                                                            <td><div className="CreateNewJob-service-table-body-description-column">{item.DESCRIPTION}</div></td>
                                                                            <td><div>{item.POINTS}</div></td>
                                                                            <td><div>{"FOC"}</div></td>
                                                                            <td>
                                                                                <div>
                                                                                    1
                                                                                </div>
                                                                            </td>
                                                                            <td><div>0</div></td>
                                                                            <td><div>0</div></td>

                                                                        </tr>
                                                                    )
                                                                })
                                                            }


                                                        </tbody>
                                                    </table>
                                                    :
                                                    null
                                                :
                                                <div className="CreateNewJob-no-redeemable-service-list">
                                                    <p>No Redeemable Service For This Customer</p>
                                                </div>
                                        }
                                    </div>

                                    :

                                    null
                            }
                        </div>

                        <div className="CreateNewJob-add-service-button-container">
                            <button onClick={() => addServiceButtonClicked()} className="common_grey_button">Add New Service</button>

                        </div>
                    </div>

                </div>

                <div className="CreateNewJob-continue-button-container">
                    <button onClick={() => clickedOnContinue()} className="common_full_width_green_button">Continue</button>
                </div>



            </div>

            {
                assignButtonClickedState &&
                <div className="Page-popup-outer">
                    <div className="Page-popup-inner">
                        <Technician_list_popup clickedOnCloseButton={clickedOnCloseButton} clickedOnSaveButton={clickedOnSaveButton} />
                    </div>
                </div>
            }

            {
                confirmJobState &&
                <div className="Page-popup-outer">
                    <div className="Page-popup-inner">
                        <Confirm_job_popup objectToSendToAPIState={objectToSendToAPIState} clickedOnCloseConfirmPopupButton={clickedOnCloseConfirmPopupButton} closePopupAfterSuccessfulJobCreation={closePopupAfterSuccessfulJobCreation} setErrorMessage={setErrorMessage} />
                    </div>
                </div>
            }

            {
                successfulJobCreationPopup &&
                <div className="Page-popup-outer">
                    <div className="Page-popup-inner">
                        <Job_creation_success_popup closePopupAfterSuccessfulJobCreation={closePopupAfterSuccessfulJobCreation} />
                    </div>
                </div>
            }

            {
                createCustomerPopup &&
                <div className="Page-popup-outer">
                    <div className="Page-popup-inner">
                        <Create_customer_popup closePopupUserCreation={closePopupUserCreation} closePopupAfterSuccessfulUserCreation={closePopupAfterSuccessfulUserCreation} setErrorMessage={setErrorMessage} mobileNumberSearched={mobileNumberSearchBoxRef.current.value} />
                    </div>
                </div>
            }


            {
                addFleetPopup &&
                <div className="Page-popup-outer">
                    <div className="Page-popup-inner">
                        <Fleet_registration_popup userName={objectToSendToAPIState.customer_name} accountNumber={objectToSendToAPIState.account_number} mobileNumber={objectToSendToAPIState.mobile_number} closePopupAddFleet={closePopupAddFleet} closePopupAfterSuccessfulFleetCreation={closePopupAfterSuccessfulFleetCreation} setErrorMessage={setErrorMessage} />
                    </div>
                </div>
            }
        </div >

    )

}

export default CreateNewJob;